import { CustomActionDto } from '@ampsec/platform-client';
import { MICROSOFT } from 'Core-utils/constants/constants';

/** Synthetic id for the top-level Microsoft tile in the actions picker (opens Microsoft filter). */
export const MICROSOFT_GROUP_CARD_ID = 'microsoft-group';

/** Synthetic id for the single "Intune - Trigger Device Reboot" action card. */
export const MICROSOFT_INTUNE_REBOOT_ACTION_ID = 'microsoft-ct-intune-reboot';

export const MICROSOFT_INTUNE_REBOOT_TITLE = 'Intune - Trigger Device Reboot';
export const MICROSOFT_INTUNE_REBOOT_DESCRIPTION =
    'Triggers a device reboot via Microsoft Intune for the Managed Device associated with the finding.';

export const isMicrosoftIntuneRebootActionId = (id?: string): boolean => id === MICROSOFT_INTUNE_REBOOT_ACTION_ID;

/** Blank stub for the top-level Microsoft tile shown in the "All" providers grid. */
export const buildMicrosoftGroupCardStub = (): CustomActionDto => ({
    id: MICROSOFT_GROUP_CARD_ID,
    displayValue: MICROSOFT,
    description: `${MICROSOFT} - Intune Action Templates`,
    meta: {
        request: {
            method: '',
            url: '',
            params: {},
            headers: {},
            payload: {
                value: '',
                kind: 'TEMPLATE',
                format: 'JSON',
            },
        },
    },
    isTemplate: true,
    kind: 'REST_ACTION',
    retryStrategy: {
        kind: 'CONSTANT_BACKOFF',
        maxRetries: 0,
        delay: 0,
    },
    createdAt: '',
    updatedAt: '',
    deletedAt: null,
});

/** Blank stub for the single "Intune - Trigger Device Reboot" action card, shown under the Microsoft filter. */
export const buildMicrosoftIntuneRebootActionStub = (): CustomActionDto => ({
    id: MICROSOFT_INTUNE_REBOOT_ACTION_ID,
    displayValue: MICROSOFT,
    description: MICROSOFT_INTUNE_REBOOT_DESCRIPTION,
    meta: {
        request: {
            method: 'POST',
            url: '',
            params: {},
            headers: {},
            payload: {
                value: '',
                kind: 'TEMPLATE',
                format: 'JSON',
            },
        },
    },
    isTemplate: true,
    kind: 'REST_ACTION',
    retryStrategy: {
        kind: 'CONSTANT_BACKOFF',
        maxRetries: 0,
        delay: 0,
    },
    createdAt: '',
    updatedAt: '',
    deletedAt: null,
});

/** Marker embedded in the built action's URL so we can recognize a saved Intune reboot action when re-opening it for edit. */
export const INTUNE_REBOOT_URL_MARKER = '/saas_assets/intune/managed-devices/';

export const isMicrosoftIntuneRebootRestAction = (action: CustomActionDto): boolean =>
    Boolean(action.meta?.request?.url?.includes(INTUNE_REBOOT_URL_MARKER));
